/**
 * PageLoading  icon等样式由各个项目的直接通过重写css实现
 */

import React from 'react';
import ReactDOM from 'react-dom';
import PageLoadingComponent from './pageLoadingComponent';

function createPageLoading() {
	const div = document.querySelector('.component-page-loading-box') || document.createElement('div');
	div.className = 'component-page-loading-box';
	document.getElementById('scale-wrapper').appendChild(div);
	return {
		renderLoading(options) {
			ReactDOM.render(<PageLoadingComponent {...options}/>, div);
		},
		destroy() {
			ReactDOM.unmountComponentAtNode(div);
			document.body.removeChild(div);
		}
	};
}

let pageLoading, saveOptions;


/**
 *
 * @param options
 * @returns {*|void}
 *
 * [options value]
 * {type, content, duration = 2000, onClose}
 */
const show = () => {
	let options = saveOptions || {};
	if (!pageLoading) pageLoading = createPageLoading();
	options.keyTime = `loading_${new Date().getTime()}`;
	options.display = true;
	saveOptions = options;
	return pageLoading.renderLoading(options);
};
const hide = () => {
	let options = saveOptions || {};
	if (!pageLoading) pageLoading = createPageLoading();
	options.display = false;
	options.keyTime = `loading_${new Date().getTime()}`;
	return pageLoading.renderLoading(options);
};
const destroy = () => {
	pageLoading && pageLoading.destroy();
};


/**
 * 默认直接加载loading
 */
show();


export default {
	show,
	hide,
	destroy
};



// WEBPACK FOOTER //
// ./src/components/public/loading/pageLoading.js